import { createAction } from 'redux-actions';
import { GET_CONFIG_SUCCESS, GET_CONTENT_FAILURE, GET_CONTENT_REQUEST, GET_CONTENT_SUCCESS } from './constants';

export const getConfigSuccess = createAction(GET_CONFIG_SUCCESS);

export const getContentRequest = createAction(GET_CONTENT_REQUEST);
export const getContentSuccess = createAction(GET_CONTENT_SUCCESS);
export const getContentFailure = createAction(GET_CONTENT_FAILURE);

